import { CreditCard, Loader2, AlertTriangle, CheckCircle2, Lock } from "lucide-react";

const fmtDate = (iso) => {
  try { return new Date(iso).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }); } catch { return ""; }
};

export const billingMessage = (st) => {
  if (!st) return "";
  const d = st.days_left;
  const dd = `${d} day${d === 1 ? "" : "s"}`;
  if (st.reason === "payment_failed") return st.state === "locked" ? "Your last payment failed and your account is now locked. Update your card to restore access." : `Your last payment failed. Update your card within ${dd} to avoid losing access.`;
  if (st.reason === "admin_override" && st.state === "locked") return "Your account has been paused by StreamWorship. Please contact support or subscribe to restore access.";
  if (st.reason === "no_subscription") return "Choose a plan to start using StreamWorship.";
  const what = st.reason === "trial_ended" ? "Your free trial has ended" : "Your subscription has ended";
  if (st.state === "final_warning") return `Final notice: ${what.toLowerCase()}. Your portal, live streams and website players will be locked in ${dd} unless you subscribe.`;
  if (st.state === "warning") return `${what}. Subscribe within ${dd} to keep your portal, live streams and players running.`;
  if (st.state === "locked") return `${what}. Your portal, live streams and website players are paused until you subscribe.`;
  return "";
};

export function BillingStatusCard({ state, onPortal, portalBusy }) {
  const ok = state.state === "active";
  const Icon = state.state === "locked" ? Lock : ok ? CheckCircle2 : AlertTriangle;
  const tone = ok ? "border-emerald-500/30 bg-emerald-500/[0.06]" : state.state === "warning" ? "border-amber-500/40 bg-amber-500/[0.08]" : "border-red-500/40 bg-red-500/[0.08]";
  let text = billingMessage(state);
  if (ok && state.has_stripe) {
    text = state.cancel_at_period_end
      ? `Your subscription is cancelled and ends on ${fmtDate(state.current_period_end)}. Renew anytime from Manage billing.`
      : `Your subscription is active${state.current_period_end ? ` — next payment ${fmtDate(state.current_period_end)}` : ""}.`;
  } else if (ok && state.reason === "trial") text = "You're on the free trial. Subscribe anytime to keep access when it ends.";
  else if (ok) text = "Your account is active.";
  return (
    <div data-testid="billing-status-card" className={`mb-8 rounded-2xl border p-5 flex flex-wrap items-center gap-4 ${tone}`}>
      <Icon className={"h-6 w-6 shrink-0 " + (ok ? "text-emerald-400" : state.state === "warning" ? "text-amber-400" : "text-red-400")} />
      <p data-testid="billing-status-text" className="text-sm text-gray-200 flex-1 min-w-[240px]">{text}</p>
      {state.has_stripe && (
        <button data-testid="billing-manage-button" onClick={onPortal} disabled={portalBusy} className="inline-flex items-center gap-2 px-4 h-10 rounded-lg text-sm font-semibold gold-gradient text-black disabled:opacity-60">
          {portalBusy ? <Loader2 className="h-4 w-4 animate-spin" /> : <CreditCard className="h-4 w-4" />} Manage billing
        </button>
      )}
    </div>
  );
}
